import {
  REQUEST_ORDER,
  RECEIVE_ORDER,
  SAVE_ORDER,
  UPDATE_PLACEMENTS_IN_ORDER,
  ORDER_FAILED,
  ADD_PLACEMENTS_TO_ORDER,
  ADD_OR_UPDATE_PLACEMENTS_IN_ORDER,
  ADD_OR_UPDATE_PACKAGES_IN_ORDER,
  DELETE_PLACEMENTS,
  RECEIVE_DELETED_PLACEMENTS,
  DELETE_PLACEMENT,
  RECEIVE_DELETED_PLACEMENT,
  REQUEST_CLONE_ORDER,
  RECEIVE_CLONE_ORDER,
  CLONE_ORDER_FAILED,
  REQUEST_PUSH_ORDER,
  RECEIVE_PUSH_ORDER,
  PUSH_ORDER_FAILED,
  DELETE_ORDER,
  REQUEST_CHANGELOG,
  RECEIVE_CHANGELOG,
  CHANGELOG_FAILED,
  PUT_ORDER_FAILED,
  UNLOCK_ORDER_FAILED,
  UPLOAD_FAILED,
  LIST_ATTACHMENTS_FAILED,
  RELAX_ORDER_FAILED,
  ORDER_NOT_RESTORED,
  UPDATE_INLINE_PLACEMENT,
  RECEIVE_CANCEL,
  SELECT_ATTACHMENT,
  UPLOAD_ATTACHMENT,
  RECEIVE_ATTACHMENT,
  LIST_ATTACHMENTS,
  RECEIVE_ATTACHMENTS,
  CANCEL_PLACEMENT,
  CANCEL_PLACEMENTS
} from '../actions/types';
import {computeTotalContractAmount} from "../utils/totalContractAmount";

export const orderRequest = (state = {}, action) => {
  let placements;
  let order;
  let set;
  let deletedIds;
  switch(action.type) {
    case RECEIVE_ORDER:
      order = action.order || {};
      updateOrderTotals(order);
      return Object.assign({}, state, {
        isFetching: false,
        order,
        placements: order.Placements || [],
        packages: order.Packages || [],
        error: null
      });
    case REQUEST_ORDER:
      return Object.assign({}, state, {
        isFetching: true,
        order: {},
        placements: [],
        packages: [],
        error: null
      });
    case SAVE_ORDER:
      return Object.assign({}, state, {
        isFetching: true,
        order: action.order || {},
        placements: action.order.Placements || [],
        packages: action.order.Packages || [],
        error: null
      });
    case UPDATE_INLINE_PLACEMENT:
      return Object.assign({}, state, {
        isFetching: false
      });
    case ORDER_FAILED:
    case PUT_ORDER_FAILED:
    case UNLOCK_ORDER_FAILED:
    case UPLOAD_FAILED:
    case LIST_ATTACHMENTS_FAILED:
    case RELAX_ORDER_FAILED:
    case ORDER_NOT_RESTORED:
      return Object.assign({}, state, {
        isFetching: false,
        isUploadingAttachment: false,
        isFetchingAttachments: false,
        error: action.error
      });
    case ADD_PLACEMENTS_TO_ORDER:
      if (!Array.isArray(action.placements)) {
        action.placements = [action.placements]
      }
      order = {
        ...state.order,
        Placements: [...state.placements, ...action.placements]
      };
      updateOrderTotals(order);
      return {
        ...state,
        order,
        placements: order.Placements,
        packages: order.Packages,
        isFetching: false,
        error: null
      };
    case UPDATE_PLACEMENTS_IN_ORDER:
      if (!Array.isArray(action.placements)) {
        action.placements = [action.placements]
      }
      placements = state.order.Placements.map(p => ({
        ...p,
        ...action.placements.find(pl => pl.id === p.id)
      }));
      order = {
        ...state.order,
        Placements: placements
      };
      updateOrderTotals(order);
      return {
        ...state,
        order,
        placements,
        packages: order.Packages,
        isFetching: false,
        error: null
      };
    case ADD_OR_UPDATE_PLACEMENTS_IN_ORDER:
      if (!Array.isArray(action.placements)) {
        action.placements = [action.placements]
      }
      const existingPlacementIds = state.order.Placements.map(p => p.id);
      const addedPlacements = action.placements.filter(p => !existingPlacementIds.includes(p.id));
      const updatedPlacements = state.order.Placements.map(p => ({
        ...p,
        ...action.placements.find(pl => pl.id === p.id)
      }));
      order = {
        ...state.order,
        Placements: [...updatedPlacements, ...addedPlacements]
      };
      updateOrderTotals(order);
      return {
        ...state,
        order,
        placements: order.Placements,
        isFetching: false,
        error: null
      };
    case ADD_OR_UPDATE_PACKAGES_IN_ORDER:
      if (!Array.isArray(action.packages)) {
        action.packages = [action.packages]
      }
      const existingPackageIds = state.order.Packages.map(p => p.id);
      const addedPackages = action.packages.filter(p => !existingPackageIds.includes(p.id));
      const updatedPackages = state.order.Packages.map(p => ({
        ...p,
        ...action.packages.find(pl => pl.id === p.id)
      }));
      order = {
        ...state.order,
        Packages: [...updatedPackages, ...addedPackages]
      };
      updateOrderTotals(order);
      return {
        ...state,
        order,
        packages: order.Packages,
        isFetching: false,
        error: null
      };
    case DELETE_ORDER:
      return Object.assign({}, state, {
        isFetching: true
      });
    case DELETE_PLACEMENT:
    case DELETE_PLACEMENTS:
    case CANCEL_PLACEMENT:
    case CANCEL_PLACEMENTS:
      return Object.assign({}, state, {
        isFetching: true
      });
    case RECEIVE_DELETED_PLACEMENTS:
      set = new Set(action.payload.deleted);
      placements = state.order.Placements.filter(p => !set.has(p.id));
      order = {
        ...state.order,
        Placements: placements
      };
      updateOrderTotals(order);
      return {
        ...state,
        order,
        placements,
        isFetching: false
      };
    case RECEIVE_DELETED_PLACEMENT:
      deletedIds = [parseInt(action.payload.deleted, 10)];
      placements = state.order.Placements.filter(p => !deletedIds.includes(p.id));
      order = {
        ...state.order,
        Placements: placements
      };
      updateOrderTotals(order);
      return {
        ...state,
        order,
        placements,
        isFetching: false
      };
    case 'EDIT_PLACEMENT_IN_ORDER':
      return Object.assign({}, state, {
        order: {
          ...state.order,
          Placements: action.placements
        }
      });
    case REQUEST_CLONE_ORDER:
      return {
        ...state,
        isCloning : true,
        clonedOrder: {},
        error: null,
        payload: action.payload
      };
    case RECEIVE_CLONE_ORDER:
      return {
        ...state,
        isCloning: false,
        clonedOrder: action.payload,
        error: null
      };
    case CLONE_ORDER_FAILED:
      return {
        ...state,
        isCloning: false,
        error: action.error
      };
    case REQUEST_PUSH_ORDER:
      return {
        ...state,
        isFetching: true,
        pushResult: {},
        error: null
      };
    case RECEIVE_PUSH_ORDER:
      return {
        ...state,
        isFetching: false,
        pushResult: action.payload.pushResult,
        order: action.payload.updatedIO,
        placements: action.payload.updatedIO.Placements
      };
    case PUSH_ORDER_FAILED:
      return {
        ...state,
        isFetching: false,
        error: action.error
      };
    case REQUEST_CHANGELOG:
      return Object.assign({}, state, {
        isFetchingLog: true,
        changeLog: [],
        error: null
      });
    case RECEIVE_CHANGELOG:
      return Object.assign({}, state, {
        isFetchingLog: false,
        order: state.order || {},
        placements: state.placements || [],
        changeLog: action.changelog || []
      });
    case CHANGELOG_FAILED:
      return Object.assign({}, state, {
        isFetchingLog: false,
        changeLog: null,
        error: action.error
      });
    case RECEIVE_CANCEL:
      let ups;
      if (!Array.isArray(action.payload)) {
        ups = [action.payload];
      } else {
        ups = action.payload;
      }
      placements = state.order.Placements.map(p => ({
        ...p,
        ...ups.find(pl => pl.id === p.id)
      }));
      order = {
        ...state.order,
        Placements: placements
      };
      updateOrderTotals(order);
      return {
        ...state,
        order,
        placements,
        isFetching: false,
        error: null
      };
    case SELECT_ATTACHMENT:
      return Object.assign({}, state, {
        attachment: action.attachment
      });
    case LIST_ATTACHMENTS:
      return Object.assign({}, state, {
        isFetchingAttachments: true
      });
    case RECEIVE_ATTACHMENTS:
      return Object.assign({}, state, {
        isFetchingAttachments: false,
        attachments:  action.attachments
      });
    case UPLOAD_ATTACHMENT:
      return Object.assign({}, state, {
         isUploadingAttachment: true
      });
    case RECEIVE_ATTACHMENT:
      return Object.assign({}, state, {
        isUploadingAttachment: false,
        attachment: action.attachment
      });
    default: {
      return state;
    }
  }
};

function updateOrderTotals(order) {
  if (!order || !order.Placements) return;

  const realPackages = (order.Packages || []).filter(pkg => pkg.name !== '{PLACEMENT}');
  const packagedPlacementIds = new Set();
  let packageCostTotal = 0;
  let unallocatedPkgCost = 0;

  // Package.cost is the source of truth for packaged budget. Placement rows can
  // drift (e.g. qty split by a stale plCount) and show ~half the package amount.
  realPackages.forEach(pkg => {
    const pkgCost = parseFloat(pkg.cost, 10) || 0;
    packageCostTotal += pkgCost;

    const pkgPlacements = order.Placements.filter(
      pl => pl.packageId === pkg.id && pl.agencyPlacementId !== 'CANCEL'
    );
    if (pkgPlacements.length === 0) {
      unallocatedPkgCost += pkgCost;
      return;
    }

    pkgPlacements.forEach(pl => packagedPlacementIds.add(pl.id));
    reconcilePackagedPlacements(pkg, pkgPlacements, pkgCost);
  });

  let unpackagedCost = 0;
  order.Placements.forEach(pl => {
    if (packagedPlacementIds.has(pl.id) || pl.agencyPlacementId === 'CANCEL') {
      return;
    }
    const ret = computeTotalContractAmount(
      pl.contractedQuantity,
      pl.ioRate,
      pl.IoRateTypeId,
      pl.start,
      pl.end,
      pl.lineItemType
    );
    pl.totalContractAmount = ret.total;
    unpackagedCost += parseFloat(ret.total, 10) || 0;
  });

  order.unallocatedPkgs = unallocatedPkgCost.toFixed(2);
  order.totalOrderAmount = (packageCostTotal + unpackagedCost).toFixed(2);
}

/**
 * Make placement qty / contract amounts sum to the parent package.
 * Quantity is split evenly (remainder on the first placements); contract amount
 * is allocated by qty share so the footer matches package.cost.
 */
function reconcilePackagedPlacements(pkg, pkgPlacements, pkgCost) {
  const pkgQty = parseInt(pkg.contractedQuantity, 10) || 0;
  const qtySum = pkgPlacements.reduce(
    (sum, pl) => sum + (parseInt(pl.contractedQuantity, 10) || 0),
    0
  );

  if (pkgQty > 0 && qtySum !== pkgQty) {
    const base = Math.floor(pkgQty / pkgPlacements.length);
    let remainder = pkgQty - base * pkgPlacements.length;
    pkgPlacements.forEach(pl => {
      pl.contractedQuantity = base + (remainder > 0 ? 1 : 0);
      if (remainder > 0) remainder -= 1;
    });
  }

  const qSum = pkgPlacements.reduce(
    (sum, pl) => sum + (parseInt(pl.contractedQuantity, 10) || 0),
    0
  ) || pkgPlacements.length;

  if (pkgPlacements.length === 1) {
    const pl = pkgPlacements[0];
    if (pkgQty > 0) {
      pl.contractedQuantity = pkgQty;
    }
    pl.totalContractAmount = pkgCost;
    return;
  }

  let allocated = 0;
  pkgPlacements.forEach((pl, i) => {
    if (i === pkgPlacements.length - 1) {
      pl.totalContractAmount = Math.round((pkgCost - allocated) * 100) / 100;
    } else {
      const share = Math.round(
        ((pkgCost * (parseInt(pl.contractedQuantity, 10) || 0)) / qSum) * 100
      ) / 100;
      pl.totalContractAmount = share;
      allocated += share;
    }
  });
}
